import { riskLevelState, task_status_ENUM } from "./enums";

export const getOptionName = (options, value) => {
  const option = options.find((item) => item.value === value);
  return option ? option.name : "-";
};

export const months = [
  { name: "Enero", value: 1 },
  { name: "Febrero", value: 2 },
  { name: "Marzo", value: 3 },
  { name: "Abril", value: 4 },
  { name: "Mayo", value: 5 },
  { name: "Junio", value: 6 },
  { name: "Julio", value: 7 },
  { name: "Agosto", value: 8 },
  { name: "Septiembre", value: 9 },
  { name: "Octubre", value: 10 },
  { name: "Noviembre", value: 11 },
  { name: "Diciembre", value: 12 }
];

/** Opciones de mes para filtros: incluye "Todos los meses" para filtrar solo por año (value "all" para que el select muestre el texto) */
export const monthsWithAll = [
  { name: "Todos los meses", value: "all" },
  ...months
];

export const getYearsFrom = (minYear = 2020) => {
  const currentYear = new Date().getFullYear();
  const startYear = Math.min(minYear, currentYear);
  const yearOptions = [];

  for (let year = currentYear; year >= startYear; year -= 1) {
    yearOptions.push({ name: String(year), value: year });
  }

  return yearOptions;
};

export const years = getYearsFrom(2020);

export const quarters = [
  { name: "Seleccionar", value: null },
  { name: "Trimestre 1: Enero - Marzo", value: 1 },
  { name: "Trimestre 2: Abril - Junio", value: 2 },
  { name: "Trimestre 3: Julio - Septiembre", value: 3 },
  { name: "Trimestre 4: Octubre - Diciembre", value: 4 }
];

export const position = [
  { name: "Todos", value: 0 },
  { name: "Gerente", value: 1 },
  { name: "Contador", value: 2 },
  { name: "Vendedor", value: 3 },
  { name: "Promotor", value: 4 },
  { name: "Axuliar contable", value: 5 }
];

export const stateDofa = [
  { name: "Activo", value: 1 },
  { name: "Inactivo", value: 2 }
];

export const typeDofa = [
  { name: "Debilidades", value: 1 },
  { name: "Oportunidades", value: 2 },
  { name: "Fortalezas", value: 3 },
  { name: "Amenazas", value: 4 }
];

export const impactData = [
  { name: "Insignificante", value: 1 },
  { name: "Menor", value: 2 },
  { name: "Moderado", value: 3 },
  { name: "Mayor", value: 4 },
  { name: "Enorme", value: 5 }
];

export const probabilityData = [
  { name: "Raro", value: 1 },
  { name: "Improbable", value: 2 },
  { name: "Posible", value: 3 },
  { name: "Probable", value: 4 },
  {
    name: "Casi seguro",
    value: 5
  }
  // { name: "Raro (puede ocurrir excepcionalmente)", value: 1 },
  // { name: "Improbable (puede ocurrir ocasionalmente)", value: 2 },
  // { name: "Posible (puede ocurrir en cualquier momento del futuro)", value: 3 },
  // { name: "Probable (probablemente va a ocurrir)", value: 4 },
  // {
  //   name: "Casi seguro (ocurre en la mayoría de las circunstancias)",
  //   value: 5
  // }
];


export const vulnerabilityData = [
  { name: "Baja", value: 1 },
  { name: "Media", value: 3 },
  { name: "Alta", value: 5 }
];

export const controlType = [
  { name: "PREVENTIVO", value: 4 },
  {
    name: "CORRECTIVO",
    value: 3
  },
  {
    name: "DETECTIVO",
    value: 2
  },
  {
    name: "INEXISTENTE",
    value: 1
  }
];

export const controlFrequency = [
  { name: "PERMANENTE", value: 3 },
  {
    name: "PERIODICO",
    value: 2
  },
  {
    name: "OCASIONAL",
    value: 1
  }
];

export const treatmentAction = [
  { name: "Evitar", value: 1 },
  {
    name: "Prevenir",
    value: 2
  },
  {
    name: "Reducir o mitigar",
    value: 3
  },
  {
    name: "Aceptar y asumir",
    value: 4
  },
  {
    name: "Retener",
    value: 5
  },
  {
    name: "Transferir",
    value: 6
  }
  // {
  //   name: "Asumir",
  //   value: 7
  // }
];

export const opportunityTreatmentAction = [
  { name: "Replantear", value: 1 },
  { name: "Adopción de nuevas prácticas", value: 2 },
  { name: "Lanzamiento de nuevos productos", value: 3 },
  { name: "Apertura a nuevos mercados", value: 4 },
  { name: "Construcción de asociaciones", value: 5 },
  { name: "Utilizando nuevas tecnologías", value: 6 },
  { name: "Otras posibilidades deseables y viables", value: 7 },
  {
    name: "Lanzamiento de nuevos productos educativos o servicios educativos",
    value: 8
  }
];

export const actionState = [
  { name: "", value: 0 },
  { name: "Abierta", value: 1 },
  {
    name: "Cerrada",
    value: 2
  }
];

export const riskStatus = [
  { name: "Materializado", value: riskLevelState.materialized },
  {
    name: "Cerrado sin Mitigación",
    value: riskLevelState.closedWithoutMitigation
  },
  {
    name: "Aceptado",
    value: riskLevelState.accepted
  },
  {
    name: "Mitigado",
    value: riskLevelState.mitigated
  },
  {
    name: "Mejorado",
    value: riskLevelState.improved
  },
  {
    name: "Latente",
    value: riskLevelState.latent
  }
];

export const YesNoOptions = [
  { label: "Sí", value: true },
  { label: "No", value: false }
];

export const YesNoOptionsSelect = [
  { name: "Sí", value: true },
  { name: "No", value: false }
];

export const YesNoNAOptions = [
  { label: "Sí", value: 1 },
  { label: "No", value: 2 },
  { label: "N/A", value: 3 }
];

export const fourMonthPeriod = [
  { name: "Primer Cuatrimestre", value: 1 },
  { name: "Segundo Cuatrimestre", value: 2 },
  { name: "Tercer Cuatrimestre", value: 3 }
];

export const opportunityState = [
  { name: "Creado", value: 1 },
  {
    name: "Activo",
    value: 2
  },
  {
    name: "Mejorado",
    value: 3
  }
];

export const technologyModalityOption = [
  { value: 1, name: "Apoyo tecnológico" },
  { value: 2, name: "Venta" },
  { value: 3, name: "Demostración" },
  { value: 4, name: "Backup" },
  { value: 5, name: "Asignado" },
  { value: 6, name: "Aprobado" },
  { value: 7, name: "Cuarentena" },
  { value: 9, name: "Destrucción" }
];

export const requestState = [
  { value: 1, name: "Apertura de Orden de Servicio" },
  { value: 2, name: "Diagnóstico" },
  { value: 3, name: "Reparación" },
  { value: 4, name: "Pruebas" },
  { value: 5, name: "Reporte de ingeniería" },
  { value: 6, name: "Entrega y cierre de OS" },
  { value: 7, name: "Alistamiento Documental y técnico" },
  { value: 8, name: "Alistamiento físico" },
  { value: 9, name: "Actividad técnica" },
  { value: 10, name: "Reporte de ingeniería" },
  { value: 11, name: "Diagnóstico II" },
  { value: 12, name: "Reparación II" },
  { value: 13, name: "Pruebas II" },
  { value: 14, name: "Entrega y cierre de OS" },
  { value: 15, name: "Acta de entrega/ Retiro" }
];

export const openClosedSelect = [
  { value: 1, name: "Abierta" },
  { value: 2, name: "Cerrada" }
];

export const usefulLifeStatusOptions = [
  { name: "Crítica (≤ 1 año)", value: "red" },
  { name: "Media (2-3 años)", value: "yellow" },
  { name: "Buena (≥ 4 años)", value: "green" }
];

export const stakeholdersEntries = [
  { name: "Interna", value: 1 },
  { name: "Externa", value: 2 }
];

export const stakeholdersRolType = [
  { name: "Decisor", value: 1 },
  { name: "Financiador", value: 2 },
  { name: "Ejecutor", value: 3 },
  { name: "Usuario final", value: 4 },
  { name: "Regulador", value: 5 },
  { name: "Influenciador", value: 6 },
  { name: "Observador", value: 7 }
];

export const stakeholderRelationselect = [
  { name: "Directa", value: 1 },
  { name: "Indirecta", value: 2 },
  { name: "Formal", value: 3 },
  { name: "Informal", value: 4 },
  { name: "Permanente", value: 5 },
  { name: "Temporal", value: 6 }
];

export const stakeholdersinfluence = [
  { name: "Esenciales", value: 1 },
  { name: "Importantes", value: 2 },
  { name: "Cooperadores", value: 3 }
];

/** Nivel de influencia en BD: entero 1, 2 o 3 (Baja, Media, Alta). */
export const stakeholderlevel = [
  { name: "Baja", value: 1 },
  { name: "Media", value: 2 },
  { name: "Alta", value: 3 }
];

export const YesNoOptionsGroup = [
  { label: "Sí", value: 1 },
  { label: "No", value: 0 }
];

export const indicatorsType = [
  { name: "Ejecutadas vs Planificadas", value: 1 },
  // { name: "Tareas no ejecutadas", value: 2 },
  { name: "Ejecutadas vs No Planificadas", value: 3 },
  { name: "Cumplimiento de Actividades Delegadas", value: 4 },
  { name: "Actividades Eliminadas", value: 5 }
];

export const managmentIndicatorsType = [
  { name: "Ejecutadas vs Planificadas", value: 1 },
  { name: "Tareas no ejecutadas", value: 2 }
];

export const taskStates = [
  { name: "Por Hacer", value: task_status_ENUM.TO_DO },
  { name: "En Proceso", value: task_status_ENUM.IN_PROCESS }
];

export const taskFullStates = [
  { name: "Por Hacer", value: task_status_ENUM.TO_DO },
  { name: "En Proceso", value: task_status_ENUM.IN_PROCESS },
  { name: "Completada", value: task_status_ENUM.COMPLETED },
  { name: "Justificada", value: task_status_ENUM.STATE_JUSTIFIED },
  { name: "Eliminada", value: task_status_ENUM.DELETED },
];
 
